import React, {Component} from 'react';
import Particles from './Particles/ListExport';
import ParticleInstance from './Particles/ParticleInstance';
import {Title, Icon} from './Basics';
import {Motion, spring} from 'react-motion';
import {connect} from 'react-redux';
import {expandParticle, closeParticle, particlePosition} from './actions';
import {scalePow} from 'd3-scale';
import {throttle} from 'lodash';
import {gaEvent} from './actions/ga.js';

import './Particle.css';

let lastId = 0;

const newId = (prefix='id') => {
  lastId++;
  return lastId;
  // return `${prefix}${lastId}`;
}

const mapStateToProps = (state) => {
  return {
    openedParticles: state.open,
    scrollPosY: state.scrollPosY,
    parentTop: state.parentTop,
    parentHeight: state.parentHeight,
    lang: state.lang
  }
};


class Particle extends Component {

  componentDidMount(){
    this.updatePosition = throttle( this.updatePosition.bind(this) , 20);
  }

  componentWillMount() {
    this.id = newId();
    this.pos = 0;
  }

  expandParticle = (event) => {
    const {number, dispatch, openedParticles} = this.props;
    const expanded = openedParticles && openedParticles[number];
    // Close Particle with Escape key when expanded,
    // or open with enter key / click
    if (event.keyCode === 27 && expanded) {
      dispatch(closeParticle(number, this.id));
      gaEvent('close', 'Particle', number);
    } else if (!event.keyCode || (event.keyCode === 13 && !expanded)) {
      gaEvent('open', 'Particle', number);
      dispatch(expandParticle(number, this.id));
    }
  }

  closeParticle = () => {
    const {number, dispatch} = (this.props);
    dispatch(closeParticle(number, this.id));
    gaEvent('close', 'Particle', number);
  }

  updatePosition = () => {
    const top = this.refs.Particle.getBoundingClientRect().top;
    this.props.dispatch(particlePosition(this.id, top));
    this.pos = top;
  }

  shouldComponentUpdate({nextProps}) {
    const {parentTop=0, parentHeight=0} = this.props;
    const margin = 50; // add a little more space to the "listening" viewport
    const top = this.refs.Particle.getBoundingClientRect().top;
    const isInViewPort = (top > (parentTop - margin) && top < (parentTop + parentHeight + margin))
    return isInViewPort;
  }

  componentDidUpdate() {
    // requestAnimationFrame(this.updatePosition);
    this.updatePosition()
  }

  render() {
    const {number, teaser, openedParticles={}, parentTop=0, parentHeight=0, lang} = this.props;
    const currentParticle = Particles[number][lang];
    const isExpanded = openedParticles[number] !== undefined;

    const isCollapsed = currentParticle && (!isExpanded || !open);
    const isHidden = isExpanded && openedParticles[number] !== this.id;

    const domain = [parentTop,  (parentTop + parentHeight) * 0.5 ,parentTop + parentHeight];

    // const scaleShiftY = scaleLinear()
    //   .domain([parentTop,  (parentTop + parentHeight) * 0.5 ,parentTop + parentHeight])
    //   .range([5, 0, -5]);

    const scaleClipY = scalePow().exponent(0.8)
      .domain(domain)
      .range([85, 200, 20]);

    // const targetPosY = scaleShiftY(this.pos);
    const targetClipY = scaleClipY(this.pos);

    return (
      <section className='Particle__wrapper' ref='Particle'>{ !isHidden &&
        <Motion
          defaultStyle={{clip: 200, shiftY: 0, height: 0}}
          style={{
            // shiftY: spring(isExpanded ? 0 : targetPosY, {stiffness: 200, damping: 20}),
            height: spring( isExpanded ? 20000 : 0, {stiffness: isExpanded ? 50 : 120, damping: 20}),
            clip: spring(targetClipY, {stiffness: 200, damping: 20})
          }}
          >
          { interpolated =>
            <div
              className={isExpanded ? 'Particle expanded' : 'Particle'}
              onClick={!isExpanded && this.expandParticle}
              onKeyDown={this.expandParticle}
              style={{ maxHeight: isExpanded ? 'none' : `${interpolated.clip}px` }}
              tabIndex={0}
              role='button'
            >
            <div className='Particle__scrollWrapper'>
                {/* Collapsed state */}
                { isCollapsed &&
                  <div className='Particle__content'>
                    <span className='visually-hidden'>Expand Particle </span>
                    <div className='Particle__meta'><Icon type={currentParticle.type}/>{currentParticle.type} {currentParticle.duration}</div>
                    <Title>{teaser || currentParticle.defaultTeaser}</Title>
                  </div>
                }

                {/* Expanded state */}
                {currentParticle && isExpanded &&
                  <div className='Particle__meta Particle__meta--expanded'>
                    <div>
                      <Icon type={currentParticle.type}/>
                      {currentParticle.type} {currentParticle.duration}
                    </div>
                    <span
                      className='Particle__close'
                      role='button'
                      onClick={this.closeParticle}>
                      ×
                    </span>
                  </div>
                }

              <div style={{ maxHeight: interpolated.height, overflow: isExpanded ? 'visible' : 'hidden'}}>
                <ParticleInstance content={currentParticle} isExpanded={isExpanded}/>
              </div>

              { !currentParticle &&
                // No matching Particle found. Oh noes!
                <div className='Particle__content'>`Particle #${number} could not be found.`</div>
              }

            </div>

            </div>
          }

        </Motion>
      }</section>
    );
  }
}

export default connect(mapStateToProps)(Particle);



/** WEBPACK FOOTER **
 ** ./src/Particle.js
 **/